import { z } from "zod";

export const connectDevicesToProviderRequestPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      registrationNumber: z.string(),
      deviceId: z.string(),
    }),
  ),
});

export type ConnectDevicesToProviderRequestPayload = z.infer<
  typeof connectDevicesToProviderRequestPayloadSchema
>;
